/* --------------------------------------------------------------------
インビュー
-------------------------------------------------------------------- */
$(function () {
    $(".fadeUp").on("inview", function () {
        $(this).addClass("active");
    });
});
$(function () {
    $(".fadeUpWrap").on("inview", function () {
        $(this).addClass("active");
    });
});

/* --------------------------------------------------------------------
MVロゴアニメーション
-------------------------------------------------------------------- */
$(function () {
    $(".mv .logo").on("inview", function () {
        $(this).addClass("active");
    });
});

/* --------------------------------------------------------------------
メッセージセクションの高さ調整
-------------------------------------------------------------------- */
$(function () {
    function adjustMessageHeight() {
        const rightImg = document.querySelector('#message .right img');
        const left = document.querySelector('#message .left');
        const right = document.querySelector('#message .right');
        
        if (rightImg && left && right) {
            // 769px以上の場合のみ高さを調整
            if (window.innerWidth >= 769) {
                const imgHeight = rightImg.offsetHeight;
                left.style.height = imgHeight + 'px';
                right.style.height = imgHeight + 'px';
            } else {
                // 768px以下の場合は高さをリセット
                left.style.height = '';
                right.style.height = '';
            }
        }
    }
    
    // ページ読み込み完了時に実行
    $(window).on('load', function() {
        adjustMessageHeight();
    });
    
    // 画像の読み込み完了時にも実行（念のため）
    $('#message .right img').on('load', function() {
        adjustMessageHeight();
    });
    
    // リサイズ時にも実行
    $(window).on('resize', function() {
        adjustMessageHeight();
    });
});

/* --------------------------------------------------------------------
パララックス効果（ラーメン画像）
-------------------------------------------------------------------- */
let parallaxState = {
  main: 0,
  first: 0,
  second: 0
};

function updateParallax() {
  const ramen = document.querySelector('.ramen');
  if (!ramen) return;
  
  const rect = ramen.getBoundingClientRect();
  const windowH = window.innerHeight;
  let target = { main: 0, first: 0, second: 0 };

  if (rect.top < windowH && rect.bottom > 0) {
    const base = rect.top - windowH / 2;
    target.main = base * 0.035;
    target.first = base * 0.084;
    target.second = base * 0.063;
  }

  // イージング（慣性）で追従
  parallaxState.main += (target.main - parallaxState.main) * 0.08;
  parallaxState.first += (target.first - parallaxState.first) * 0.08;
  parallaxState.second += (target.second - parallaxState.second) * 0.08;

  $('.ramen .main').css('transform', `translateY(${parallaxState.main}px)`);
  $('.ramen .inc.first').css('transform', `translateY(${parallaxState.first}px) scale(1.02)`);
  $('.ramen .inc.second').css('transform', `translateY(${parallaxState.second}px) scale(0.99)`);

  requestAnimationFrame(updateParallax);
}

$(function () {
  requestAnimationFrame(updateParallax);
  $(window).on('resize', updateParallax);
});






